/** Stepper state of the step at `index` while the wizard is on `currentIndex`. */
export const stepStateOf = (index, currentIndex) => {
  if (index < currentIndex) return 'completed';
  return index === currentIndex ? 'current' : 'upcoming';
};
